import React, { useCallback, useEffect, useState } from "react";
import { Route, Switch, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ErrorBoundary from "./pages/error/ErrorBoundary";
import Intro from "./pages/intro/Intro";
import Home, { JudicialDocuments } from "./pages/home/Home";
import Login from "./pages/login/Login";
import Navbar from "./components/Navbar";
import Archive from "./pages/archive/Archive";
import Wiki from "./pages/wiki/Wiki";
import Support from "./pages/supports/Support";
import LBS from "./pages/lbs/LBS";
import Consulting from "./pages/consulting/Consulting";
// import Chat from "./pages/chat/Chat";
// import Blog from "./pages/blog/Blog";
// import ContentDetail from "./pages/blog/components/ContentDetail";
import WikiContentDetail from "./pages/wiki/WikiContentDetail";
import Menu from "./pages/menu/Menu";
import Profile from "./pages/profile/Profile";
import Setting from "./pages/setting/Setting";
import Terms from "./pages/login/terms/Terms";
import Payment from "./pages/chat/payment/Payment";
import Invoice from "./pages/chat/invoice";
import WikiCalculator from "./pages/wiki/calculator/Calculator";
import WikiPerCategory from "./pages/wiki/perCategory/WikiPerCategory";
import AboutUs from "./pages/about-us/AboutUs";
import PrivateRoute from "./components/PrivateRoute";
import Transactions from "./pages/transactions/Transactions";
import Faq from "./pages/faq/Faq";
import PaymentResult from "./pages/chat/payment/PaymentResult";
import Messages from "./pages/messages/Messages";
import Help from "./pages/help";
import BottomSheet from "./components/BottomSheet";
import ClientAccess from "./pages/profile/ClientAccess";
import PdfEditor from "./pages/pdf-editor/PdfEditor";
import LinkedinInPopup from "./pages/login/loginSocialMedia/LinkedinInPopup";
import { fetchProfile } from "./actions/profile";
import { checkValue } from "./constant/helper";
import "./styles/ant.less";
import "./styles/app.scss";
import ChatPage from "./pages/chat/ChatPage";
import supportchatPage from "./pages/supports/supportchatPage";
import NewVersion from "./NewVersion";
import { Spin } from "antd";
// import VoiceCall from "./pages/voice-call/VoiceCall";
// import VoiceCallPayment from "./pages/voice-call/VoiceCallPayment";
// import VoiceCallDetail from "./pages/voice-call/VoiceCallDetail";

const params = new URLSearchParams(window.location.search);
if (params.has("startSession")) {
  localStorage.setItem("startSession", params.get("startSession"));
}

export default function App() {
  const [error, setError] = useState(null);
  const [showLawyerAccessDenied, setShowLawyerAccessDenied] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();

  const {
    data,
    loading,
    error: profileError,
  } = useSelector((state) => state.profile);
  const [profileFetchLoading, setProfileFetchLoading] = useState(true);
  useEffect(() => {
    dispatch(fetchProfile(dispatch));
    // eslint-disable-next-line
  }, []);

  const { profile } = useSelector((state) => state);
  useEffect(() => {
    profile &&
      setTimeout(() => {
        setProfileFetchLoading(false);
      }, 500);
  }, [profile]);

  useEffect(() => {
    if (!loading && !profileError && data) {
      if (data.hasOwnProperty("extraInfo") && checkValue(data.extraInfo)) {
        if (
          data.extraInfo.hasOwnProperty("tag") &&
          checkValue(data?.extraInfo.tag)
        ) {
          if (data?.extraInfo.tag.toLowerCase() !== "client") {
            setShowLawyerAccessDenied(true);
          }
        } else {
          setShowLawyerAccessDenied(true);
        }
      }
    }
    // eslint-disable-next-line
  }, [loading, profileError]);

  const withNavbarRoutes = useCallback(() => {
    return (
      <>
        <PrivateRoute path="/home" component={Archive} exact />
        {/* <PrivateRoute path="/archive" component={Archive} exact /> */}
        <PrivateRoute path="/wiki" component={Wiki} exact />
        <PrivateRoute path="/lbs" component={LBS} exact />
        <PrivateRoute path="/menu" component={Menu} exact />
        <PrivateRoute path="/help" component={Help} exact />
        <Navbar />
      </>
    );
  }, []);

  return (
    <>
      {/* new version confirm modal */}
      <NewVersion />
      {/* App Router */}
      <ErrorBoundary
        resetErrorBoundary={() => {
          setError(null);
          history.go(-1);
        }}
        error={error}
        onError={setError}
      >
        <>
          <Spin spinning={profileFetchLoading}>
            <Switch>
              <Route path="/successResult" component={PaymentResult} exact />

              <PrivateRoute path="/consulting" component={Home} exact />
              <PrivateRoute
                path="/consulting/contracts_and_judicial_documents"
                component={JudicialDocuments}
                exact
              />
              {/* <PrivateRoute
                path="/consulting/voice-call"
                component={VoiceCall}
                exact
              />
              <PrivateRoute
                path="/consulting/voice-call/:id"
                component={VoiceCall}
                exact
              /> */}
              {/* <PrivateRoute
                path="/consulting/voice-call/:id/pay"
                component={VoiceCallPayment}
                exact
              /> */}
              <PrivateRoute
                path="/consulting/:rootType"
                component={Consulting}
                exact
              />

              {/* <PrivateRoute
                path="/call/:id"
                component={VoiceCallDetail}
                exact
              /> */}

              <PrivateRoute
                path="/pdf-editor/:sessionId/:fileId/:consultationStatus"
                component={PdfEditor}
                exact
              />

              <Route path="/" component={Intro} exact />
              <Route path="/login" component={Login} exact />
              <Route exact path="/linkedin" component={LinkedinInPopup} />

              <PrivateRoute path="/messages" component={Messages} exact />
              <PrivateRoute
                path="/consultation/:rootType/:sessionId"
                component={ChatPage}
                exact
              />
              <PrivateRoute
                path="/consultation/:rootType/:sessionId/payment"
                component={Payment}
                exact
              />
              <PrivateRoute
                path="/consultation/:rootType/:sessionId/invoice"
                component={Invoice}
                exact
              />
              <PrivateRoute
                path="/consultation/:rootType/:sessionId/:status"
                component={ChatPage}
                exact
              />

              <PrivateRoute
                path="/wiki/contents/:contentId"
                component={WikiContentDetail}
                exact
              />
              <PrivateRoute
                path="/wiki/calculator"
                component={WikiCalculator}
                exact
              />
              <PrivateRoute
                path="/wiki/category/:categoryId"
                component={WikiPerCategory}
                exact
              />

              <PrivateRoute path="/wiki/:parentId" component={Wiki} exact />

              <PrivateRoute path="/profile" component={Profile} exact />
              <PrivateRoute path="/setting" component={Setting} exact />
              <PrivateRoute path="/faq" component={Faq} exact />
              {/* <PrivateRoute path="/blog" component={Blog} exact />
              <PrivateRoute path="/blog/:id" component={ContentDetail} exact /> */}
              <PrivateRoute
                path="/transactions"
                component={Transactions}
                exact
              />
              <PrivateRoute
                path="/transactions/:sessionId"
                component={Transactions}
                exact
              />
              <PrivateRoute path="/support" component={Support} exact />
              <PrivateRoute
                path="/support/:id"
                component={supportchatPage}
                exact
              />
              <PrivateRoute path="/about-us" component={AboutUs} exact />
              <PrivateRoute path="/terms" component={Terms} exact />

              <Route component={withNavbarRoutes} />
            </Switch>
          </Spin>
          <BottomSheet
            isOpen={showLawyerAccessDenied}
            classNames="client-access-holder right-text"
          >
            <ClientAccess />
          </BottomSheet>
        </>
      </ErrorBoundary>
    </>
  );
}
